<template>
  <div id="dl-card" class="container-card">
    <div class="external">
      <img
        class="image"
        v-if="imgFound"
        :src="media_url"
        @error="imgFound = false"
        :alt="nome_media">

      <img alt="placeholder" class="image place" v-else-if="imgFound === false" :src="url('/storage/downloads/placeholder-download.jpg')">
    </div>

    <div class="description">
      <h2 class="titolo">{{ nome_documento }}</h2>
      <p class="download">
        <a target="_blank" :href="file_url" :title="nome_file"
          ><span>Download</span> <img :src="url('/storage/media/icons/download.svg')" alt="dld icon"></a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "dl-card",
  props: [
    "file_url",
    "id",
    "media_url",
    "nome_documento",
    "nome_file",
    "nome_media",
  ],
  data() {
    return {
      imgFound: true,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
#dl-card.container-card {
  font-size: 1rem;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }

  .external {
    width: 100%;
    .image {
      width: 100%;
      //height: 303px;
    }
  }

  .description {
    width: 100%;
    height: 85px;
    background-color: #2f2f34;
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .titolo {
      margin-bottom: 20px;
      color: var(--text-white);
    }

    .download {
      cursor: pointer;
      margin-left: auto;
      color: #abc932;
      a {
        display: flex;
        align-items: baseline;
        img {
          margin-left: 5px;
        }
      }

      span {
        display: inline-block;
      }
    }

    .download:hover {
      i {
        transform: scale(1.1);
      }
    }
  }
}
img {
  display: inline-block;
}
</style>
